import { Directive, ElementRef, Renderer2, HostListener, Output, EventEmitter, AfterViewInit, Input } from '@angular/core';

@Directive({
  selector: '[divOverflow]'
})
export class OverflowDirective implements AfterViewInit {
  @Output() overflow = new EventEmitter<boolean>();
  @Output() atStart = new EventEmitter<boolean>();
  @Output() atEnd = new EventEmitter<boolean>();

  @Input() divOverflow: string = 'width'

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.checkOverflow();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkOverflow();
  }

  @HostListener('scroll')
  onScroll() {
    this.checkOverflow();
  }

  private checkOverflow() {
    if (this.divOverflow == 'height') {
      const nativeElement = this.el.nativeElement;

      // Debug logging
      // console.log('scrollHeight:', nativeElement.scrollHeight);
      // console.log('clientHeight:', nativeElement.clientHeight);
      // console.log('offsetHeight:', nativeElement.offsetHeight);
      // console.log('window height:', window.innerHeight);

      const hasOverflow = nativeElement.scrollHeight > nativeElement.clientHeight;
      const atTop = nativeElement.scrollTop <= 50; // Check if scroll is at start or within 50px offset
      const atBottom = nativeElement.scrollTop + nativeElement.clientHeight + 50 >= nativeElement.scrollHeight; // Check if scroll is at end or within 50px offset

      this.overflow.emit(hasOverflow);
      this.atStart.emit(atTop);
      this.atEnd.emit(atBottom);
    }

    else {
      const nativeElement = this.el.nativeElement;
      const hasOverflow = nativeElement.scrollWidth > nativeElement.clientWidth;
      const atStart = nativeElement.scrollLeft <= 50; // Check if scroll is at start or within 50px offset
      const atEnd = nativeElement.scrollLeft + nativeElement.clientWidth + 50 >= nativeElement.scrollWidth; // Check if scroll is at end or within 50px offset

      this.overflow.emit(hasOverflow);
      this.atStart.emit(atStart);
      this.atEnd.emit(atEnd);
    }
  }
}
